import { s2Domain, seoImagePath } from 'config/google';
import { DefaultSeoProps } from 'next-seo';

const config: DefaultSeoProps = {
  openGraph: {
    type: 'website',
    images: [
      {
        url: `${s2Domain}${seoImagePath}`,
      },
    ],
    siteName: 'BlockFin',
  },
  twitter: {
    site: 'BlockFin',
    cardType: 'summary_large_image',
  },
};

export default config;
